import React, { useState, useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { LanguageContext } from "../contexts/LanguageContext"; // Dil çevirileri için context
import logo from "../assets/images/logo.png";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ResetPasswordPage = ({ email }) => {
  const { resetPassword } = useContext(AuthContext);
  const { translations } = useContext(LanguageContext); // Dil çevirileri
  const [verificationCode, setVerificationCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleResetPassword = async () => {
    if (verificationCode.length !== 6) {
      setErrorMessage(translations.invalidVerificationCode);
      return;
    }
    if (!newPassword || !confirmPassword) {
      setErrorMessage(translations.emptyPasswordFields);
      return;
    }
    if (newPassword !== confirmPassword) {
      setErrorMessage(translations.passwordsDoNotMatch);
      return;
    }

    setLoading(true);
    const response = await resetPassword({
      email,
      verificationCode,
      newPassword,
    });
    setLoading(false);

    if (response.success) {
      toast.success(translations.passwordResetSuccess, {
        autoClose: 5000, // 5 saniyede kapanır
        onClose: () => navigate("/chat/login"), // Toast kapandığında yönlendirme
      });
    } else {
      setErrorMessage(response.message);
    }
  };

  

  return (
    <div className="container-fluid vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="row w-100 h-100">
        {/* Sol Panel */}
        <div className="col-lg-6 d-none d-lg-flex flex-column align-items-center justify-content-center text-white bg-dark">
          <h1 className="display-4 fw-bold">{translations.secureAccount}</h1>
          <p className="text-center px-4">{translations.resetPasswordSubtitle}</p>
        </div>

        {/* Sağ Panel */}
        <div className="col-lg-6 d-flex flex-column align-items-center justify-content-center">
          <div className="text-center mb-4">
            <img src={logo} alt="Company Logo" style={{ maxWidth: "150px" }} className="img-fluid" />
          </div>
          <div className="card p-4 shadow" style={{ maxWidth: "400px", width: "100%" }}>
            <h2 className="text-center mb-4">{translations.resetPasswordTitle}</h2>
            <form>
              <div className="mb-3">
                <label htmlFor="verificationCode" className="form-label">
                  {translations.verificationCodeLabel}
                </label>
                <input
                  type="text"
                  id="verificationCode"
                  className="form-control"
                  placeholder={translations.verificationCodePlaceholder}
                  value={verificationCode}
                  onChange={(e) => setVerificationCode(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="newPassword" className="form-label">
                  {translations.newPasswordLabel}
                </label>
                <input
                  type="password"
                  id="newPassword"
                  className="form-control"
                  placeholder={translations.newPasswordPlaceholder}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="confirmPassword" className="form-label">
                  {translations.confirmPasswordLabel}
                </label>
                <input
                  type="password"
                  id="confirmPassword"
                  className="form-control"
                  placeholder={translations.confirmPasswordPlaceholder}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
              {errorMessage && (
                <div className="alert alert-danger text-center">{errorMessage}</div>
              )}
              <button
                type="button"
                className="btn btn-primary w-100"
                onClick={handleResetPassword}
                disabled={loading}
              >
                {loading ? translations.resetting : translations.resetPasswordButton}
              </button>
            </form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default ResetPasswordPage;